<div class="page-maintenance-mode">
  <div class="container">
    <img src="assets/images/investments/held.svg" alt="Maintenance mode icon" />

    <h2>{{ 'network_maintenance_screen_title' | translate }}</h2>
    <p>{{ 'network_maintenance_screen_header' | translate }}</p>
    <p>{{ 'network_maintenance_screen_description' | translate }}</p>
  </div>
</div>
